var map = {
	"./accia-1.png": 3552,
	"./accia-2.png": 8219,
	"./american_football.png": 6750,
	"./ava.png": 6906,
	"./baseball.png": 7261,
	"./basketball.png": 3643,
	"./card.png": 4020,
	"./gi-american-f.png": 7804,
	"./gi-arrow-bot-g.png": 5653,
	"./gi-arrow-bot.png": 7963,
	"./gi-arrow-right.png": 9842,
	"./gi-baseball.png": 6167,
	"./gi-basketball.png": 5416,
	"./gi-clock.png": 6679,
	"./gi-coin-w.png": 5300,
	"./gi-coin.png": 2187,
	"./gi-football.png": 4984,
	"./gi-gift.png": 5539,
	"./gi-gmail.png": 4444,
	"./gi-golf.png": 2859,
	"./gi-hockey.png": 5270,
	"./gi-lk-bonus.png": 2544,
	"./gi-lk-history.png": 8241,
	"./gi-lk-mypary.png": 3361,
	"./gi-lk-popvip.png": 8256,
	"./gi-lk-profile.png": 5566,
	"./gi-lk-stat.png": 8365,
	"./gi-lk-tehpod.png": 7100,
	"./gi-lk.png": 5094,
	"./gi-mail.png": 1683,
	"./gi-phone.png": 8813,
	"./gi-rus-biliard.png": 5835,
	"./gi-rus.png": 6398,
	"./gi-search.png": 8773,
	"./gi-shedule.png": 9984,
	"./gi-star.png": 210,
	"./gi-telega.png": 6219,
	"./gi-tennis.png": 9582,
	"./gi-tick.png": 3690,
	"./gi-vip.png": 3665,
	"./gi-volleyball.png": 2217,
	"./gi-zenit.png": 8368,
	"./golf.png": 6491,
	"./head-slider-1.png": 2876,
	"./icehockey.png": 1055,
	"./logo.png": 4427,
	"./purchase/accia-1.png": 3860,
	"./purchase/accia-2.png": 6987,
	"./purchase/card.png": 485,
	"./purchase/gi-american-f.png": 502,
	"./purchase/gi-arrow-bot-g.png": 163,
	"./purchase/gi-arrow-bot.png": 7764,
	"./purchase/gi-arrow-right.png": 1510,
	"./purchase/gi-baseball.png": 8430,
	"./purchase/gi-basketball.png": 3602,
	"./purchase/gi-clock.png": 9336,
	"./purchase/gi-coin-w.png": 7436,
	"./purchase/gi-coin.png": 9703,
	"./purchase/gi-football.png": 954,
	"./purchase/gi-gift.png": 7506,
	"./purchase/gi-gmail.png": 161,
	"./purchase/gi-golf.png": 1577,
	"./purchase/gi-hockey.png": 1972,
	"./purchase/gi-lk-bonus.png": 8210,
	"./purchase/gi-lk-history.png": 8265,
	"./purchase/gi-lk-mypary.png": 9898,
	"./purchase/gi-lk-popvip.png": 2498,
	"./purchase/gi-lk-profile.png": 8505,
	"./purchase/gi-lk-stat.png": 6915,
	"./purchase/gi-lk-tehpod.png": 1411,
	"./purchase/gi-lk.png": 2030,
	"./purchase/gi-mail.png": 6239,
	"./purchase/gi-phone.png": 791,
	"./purchase/gi-rus-biliard.png": 6123,
	"./purchase/gi-rus.png": 7027,
	"./purchase/gi-search.png": 9390,
	"./purchase/gi-shedule.png": 1837,
	"./purchase/gi-star.png": 6087,
	"./purchase/gi-telega.png": 1342,
	"./purchase/gi-tennis.png": 8674,
	"./purchase/gi-tick.png": 3960,
	"./purchase/gi-vip.png": 173,
	"./purchase/gi-volleyball.png": 894,
	"./purchase/gi-zenit.png": 8967,
	"./purchase/head-slider-1.png": 4152,
	"./purchase/sl-logo.png": 7109,
	"./purchase/stavki-cyber.png": 684,
	"./rus_biliard.png": 320,
	"./sl-logo.png": 6339,
	"./soccer.png": 628,
	"./stavki-cyber.png": 989,
	"./tennis.png": 7416,
	"./volleyball.png": 5218
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;